// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"169":"1155a6fe","827":"2b5a4366"}[chunkId] + ".css";
};